module.exports = __webpack_public_path__ + "img/stock4.97d2c978.png";